import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../style/home.scss';
import GoogleSignInButton from '../login/GoogleSignInButton';
import TopBar from '../commons/TopBar';
import EmrFeatures from "./EmrFeatures";

const Home = () => {
    const featuresRef = useRef<HTMLDivElement>(null);
    const cardsRef = useRef<HTMLDivElement[]>([]);
    const highlightRef = useRef<HTMLSpanElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -100px 0px'
            }
        );

        if (featuresRef.current) {
            observer.observe(featuresRef.current);
        }

        cardsRef.current.forEach((card) => {
            if (card) {
                observer.observe(card);
            }
        });

        return () => {
            if (featuresRef.current) {
                observer.unobserve(featuresRef.current);
            }
            cardsRef.current.forEach((card) => {
                if (card) {
                    observer.unobserve(card);
                }
            });
        };
    }, []);

    useEffect(() => {
        if (highlightRef.current) {
            setTimeout(() => {
                if (highlightRef.current) {
                    highlightRef.current.classList.add('highlight-animate');
                }
            }, 100); // 자연스러운 효과를 위해 약간의 딜레이
        }
    }, []);

    return (
        <div className="home-container">
            <TopBar/>
            <div className="main-content">
                <section className="hero-section">
                    <h1 className="hero-title">
                        <span ref={highlightRef} className="highlight-text">
                            Empower Healthcare Education
                        </span>
                        <br/>
                        with Academic EMR for All.

                    </h1>
                    <div className="hero-subtitle">FREE and EASY way to Create Academic EMR <br/> for your case scenarios using google sheets!</div>
                </section>
                <section className="features-section">
                    <div ref={featuresRef} className="features-grid">
                        {EmrFeatures.map((feature, index) => {
                            const hasQuestion = !!feature.question;
                            return (
                                <div key={index} className="feature-card">
                                    {hasQuestion ? (
                                        <div className="feature-content qa-content">
                                            <h3 className="question">{feature.question}</h3>
                                            <hr className="divider" />
                                            <p className="answer">{feature.answer}</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="feature-content">
                                                <h3>{feature.title}</h3>
                                                <p>{feature.description}</p>
                                            </div>
                                            <div className="feature-image">
                                                <img src={feature.image} alt={feature.title} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </section>
            </div>
        </div>
    );
};
export default Home;